<template>
    <div class="mask" @click="close">
        <div class="pop" @click.stop>
            <i class="close" @click="close"></i>
            <div class="pop-h">
                <i class="logo"></i>
                <p class="slogan">博牛投资&nbsp;&nbsp;|&nbsp;&nbsp;金融科技智造价值</p>
            </div>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        close() {
            this.$root.$emit('closePop');
        }
    }
}
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    z-index: 3;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.65);
}
.pop {
    position: absolute;
    left: 50%;
    top: 50%;
    background: #ffffff;
    transform: translate(-50%, -50%);
    width: 550px;
    border-radius: 18px;
    padding: 40px 30px 39px 30px;
    box-sizing: border-box;
    .logo {
        background: url("../../assets/img/Popup-logo.jpg");
        width: 103px;
        height: 75px;
        background-size: 103px 75px;
        display: block;
        margin: auto;
        margin-bottom: 30px;
    }
    .slogan {
        color: #022F72;
        font-size: 24px;
        margin: auto;
        margin-bottom: 32px;
        font-weight: 800;
    }
    .close {
        display: block;
        position: absolute;
        width: 32px;
        height: 33px;
        background-image: url('../../assets/img/close.png');
        right: 27px;
        top: 29px;
    }
}
</style>